import { OfferingType } from '../../../../graphql';
import { useGetCountryExcludedTypes } from './useGetCountryExcludedTypes';
import { useGetGroupExcludedTypes } from './useGetGroupExcludedTypes';
import { useGetTraitExcludedOfferingTypes } from './useGetTraitExcludedOfferingTypes';

export type Props = Readonly<{
  offeringType: OfferingType | null;
  countryCode: string;
}>;

export const useGetExcludedOfferingTypes = ({
  offeringType,
  countryCode,
}: Props): OfferingType[] => {
  const groupExcluded = useGetGroupExcludedTypes({ offeringType });
  const countryExcluded = useGetCountryExcludedTypes({ countryCode });
  const traitExcluded = useGetTraitExcludedOfferingTypes();

  return [...new Set([...groupExcluded, ...countryExcluded, ...traitExcluded])];
};
